import { COURSE_TYPES } from 'constants/common';

export const convertDataToApi = (data: any) => {
  const payload: any = {
    type: COURSE_TYPES.DAILY_CHALLENGE,
    platform: data.platform.value,
    schoolId: data.school.value,
  };

  if (data.scheduledDay) {
    payload.scheduledDay = data.scheduledDay;
  }

  return payload;
};
